import { useRef, useState, useEffect, useCallback, useMemo } from "react";

import {
  FaCaretLeft,
  FaCaretRight,
  FaPlus,
  FaCircleXmark,
  FaSquare,
  FaCircle,
  FaXmark ,
} from "react-icons/fa6";
import { FaSave } from "react-icons/fa";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import Notification from "../component/utility/Notification";
import {
  activateCustomer,
  deActivateCustomer,
  deleteCustomer,
  getCustomerList,
  getNewCustomerCode,
  saveCustomer,
  updateCustomer,
} from "../service/CustomerService";
import { getActiveRouteList } from "../service/RouteService";
import { getSampleListByCustomerIdWithRecentTrackingLog } from "../service/SampleService";
import SampleActivateSlideBar from "../component/slidebar/SampleActivateSlideBar";
import { getTicketListByCustomerCode } from "../service/TicketService";
import TicketUpdateSlideBar from "../component/slidebar/TicketUpdateSlideBar";
import TicketViewSlideBar from "../component/slidebar/TicketViewSlideBar";
import { getRecentInstalmentByTicketId } from "../service/RegularTicketInstalmentService";

export default function Customer() {
  const loggedUser = JSON.parse(
    atob(sessionStorage.getItem("x$sk72hyQwersgyhk"))
  );

  /****** Left Pane - start *****************************************************************************************************************/
  const [leftPaneStyle, setLeftPaneStyle] = useState("w-1/5");
  const [isLeftPaneExpanded, setIsLeftPaneExpanded] = useState(false);
  const [leftPaneExpandedButtonIcon, setLeftPaneExpandedButtonIcon] = useState(
    <FaCaretRight size={36} />
  );

  //++++ Customer List DataTable  ++++++++++++++++++++++++++++++++
  const customerTableRef = useRef();
  const [paginationlHide, setPaginationlHide] = useState(true);
  const [customerTableRowData, setCustomerTableRowData] = useState([]);

  const [customerTableColumnDefs, setCustomerTableColumnDefs] = useState([
    {
      colId: "id",
      valueGetter: (r) => r.data.id,
      flex: 1,
      hide: true,
    },
    {
      colId: "index",
      headerName: "#",
      valueGetter: (r) => r.data.index,
      flex: 0.3,
      hide: true,
    },
    {
      colId: "code",
      headerName: "Customer Code",
      valueGetter: (r) => r.data.code,
      filter: true,
      flex: 1,
    },
    {
      colId: "name",
      headerName: "Name",
      valueGetter: (r) => r.data.name,
      filter: true,
      flex: 1,
      hide: true,
    },
    {
      colId: "route",
      headerName: "Route",
      valueGetter: (r) => r.data.route.name,
      filter: true,
      flex: 1,
      hide: true,
    },
    {
      colId: "phone1",
      headerName: "Phone 1",
      valueGetter: (r) => r.data.phone1,
      filter: true,
      flex: 1,
      hide: true,
    },
    {
      colId: "phone2",
      headerName: "Phone 2",
      valueGetter: (r) => r.data.phone2,
      filter: true,
      flex: 1,
      hide: true,
    },
    {
      colId: "createdAt",
      headerName: "Registered Date",
      valueGetter: (r) => r.data.createdAt.replace("T", " "),
      flex: 1,
      hide: true,
    },
    {
      colId: "active",
      headerName: "Status",
      valueGetter: (r) => r.data.active,
      filter: true,
      flex: 1,
      hide: true,
    },
  ]);

  // functions
  const handleExpandLeftPane = () => {
    if (!isLeftPaneExpanded) setIsLeftPaneExpanded(true);
    else setIsLeftPaneExpanded(false);

    if (isLeftPaneExpanded) {
      setLeftPaneStyle("w-1/5");
      setLeftPaneExpandedButtonIcon(<FaCaretRight size={36} />);

      customerTableRef.current.api.setColumnsVisible(
        ["name", "route", "phone1", "phone2", "createdAt", "active"],
        false
      );
      setPaginationlHide(true);
    } else {
      setLeftPaneStyle("w-screen");
      setLeftPaneExpandedButtonIcon(<FaCaretLeft size={36} />);

      customerTableRef.current.api.setColumnsVisible(
        ["name", "route", "phone1", "phone2", "createdAt", "active"],
        true
      );
      setPaginationlHide(false);
    }
  };

  const fetchCustomerTableData = async () => {
    try {
      const res = await getCustomerList(loggedUser.token);      
      if (res !== undefined) {
        for (let i = 0; i < res.data.length; i++) {
          res.data[i].index = i + 1;
        }
        setCustomerTableRowData(res.data);
      } else {
        setCustomerTableRowData([]);
      }
    } catch (error) {
      console.error("Customer -> fetchCustomerTableData: ", error);
    }
  };

  useEffect(() => {
    fetchCustomerTableData();
  }, []);

  const handledOnRowClick = useCallback(() => {
    const selectedRows = customerTableRef.current.api.getSelectedRows();
    
    if (selectedRows.length === 1) {
      setCustomerFormData((prevState) => ({
        ...prevState,
        id: selectedRows[0].id,
        code: selectedRows[0].code,
        name: selectedRows[0].name,
        address: selectedRows[0].address,
        phone1: selectedRows[0].phone1,
        phone2: selectedRows[0].phone2,
        active: selectedRows[0].active,
        routeId: selectedRows[0].route.id,
      }));

      setOperationMode("update");
      setApiResponse({
        status: "",
        message: "Finished loading : " + selectedRows[0].name,
      });
      setCustomerStatus(selectedRows[0].active);
      setIsValidInputs(true);
      
      setActivatingSample('')
      setUpdatingTicket('')
      setViewingTicket('')
      //fetchSampleTableData(selectedRows[0].id)
      fetchTicketTableData(selectedRows[0].code)
    }
  }, []);


  

  /****** Left Pane - end *******************************************************************************************************************/

  /****** Right Pane - start ****************************************************************************************************************/

  //++++ Button Container  ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  const [operationMode, setOperationMode] = useState("new"); // "new", "save", or "update"
  const [apiResponse, setApiResponse] = useState({
    //status: true, data: null, message: 'Already added : Fabric'
    status: "",
    message: "",
  });

  const [customerStatus, setCustomerStatus] = useState("Active");

  const handleNewButton = async () => {
    initialize();
    //generate customer code
    let res = await getNewCustomerCode(loggedUser.token);

    if (res.status) {
      setCustomerFormData({
        code: res.data,
      });
      setApiResponse({ status: "", message: "Add New Customer" });
    } else {
      setApiResponse({ status: false, message: "Server Error" });
    }
  };


  const handleSaveButton = async (e) => {
    e.preventDefault();
    setIsValidInputs(true);

    let customer = {
      id: customerFormData.id,
      code: customerFormData.code,
      name: customerFormData.name,
      address: customerFormData.address,
      phone1: customerFormData.phone1,
      phone2: customerFormData.phone2,
      active: 'Active',
      routeId: customerFormData.routeId,
    };

    let resCustomer = null;

    if (isValidInputs()) {
      if (operationMode === "new") {
        resCustomer = await saveCustomer(loggedUser.token, customer);

        setApiResponse({ status: resCustomer.status, message: resCustomer.message });

        if (resCustomer != null) {
          if (resCustomer.status) {
            initialize();
          }
        }

      } else if (operationMode === "update") {
        resCustomer = await updateCustomer(loggedUser.token, customer);

        setApiResponse({ status: resCustomer.status, message: resCustomer.message });

        if (resCustomer != null) {
          if (resCustomer.status) {
            initialize();
          }
        }
      } else {
        setApiResponse({ status: false, message: "Error" });
      }
    } else {
      setApiResponse({
        status: false,
        message: "Error saving : Invalid inputs",
      });
    }      

    fetchCustomerTableData();
  };
    

  const handleDeleteButton = async (e) => {
    e.preventDefault();
    let res = null;

    if (customerFormData.name) {      
      res = await deleteCustomer(loggedUser.token, customerFormData.id);
      setApiResponse({ status: res.status, message: res.message });

      if (res.status) {
        initialize();
      } else {
        setApiResponse({ status: false, message: "Error deleting..." });
      }        
    }
      
    fetchCustomerTableData();
    
  };


  const handleActiveButton = async (e) => {
    e.preventDefault();
    let res = null;

    if (customerStatus === "Active") {
      res = await deActivateCustomer(loggedUser.token, customerFormData.id);
      setApiResponse({ status: res.status, message: res.message });
      setCustomerStatus("Inactive");
    }

    if (customerStatus === "Inactive") {
      res = await activateCustomer(loggedUser.token, customerFormData.id);
      setApiResponse({ status: res.status, message: res.message });
      setCustomerStatus("Active");
    }

    fetchCustomerTableData();
  };

  //++++ Customer info Tab Pane  ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // Basic Inputs
  const [customerFormData, setCustomerFormData] = useState({
    id: "",
    code: "",
    name: "",
    address: "",
    phone1: "",
    phone2: "",
    active: "Active",
    routeId: 0,
    errors: {},
  });

  const handleBasicInputChange = (e) => {
    const { name, value } = e.target;
    setCustomerFormData((prevState) => ({ ...prevState, [name]: value }));
  };

  // route drop down box
  const [activeRouteList, setActiveRouteList] = useState([]);

  const fetchActiveRouteList = async () => {
    try {
      const req = await getActiveRouteList(loggedUser.token);
      setActiveRouteList(req.data);
    } catch (error) {
      console.log(error);
    }
  };

  // fetch route list to dropdown
  useEffect(() => {
    fetchActiveRouteList();
  }, []);

  // Validation
  const [isValidCode, setIsValidCode] = useState(true);
  const [isValidName, setIsValidName] = useState(true);
  const [isValidRoute, setIsValidRoute] = useState(true);
  const [isValidPhone1, setIsValidPhone1] = useState(true);


  const isValidInputs = () => {
    const errors = {};

    if (customerFormData.code === "") {
      setIsValidCode(false);
      errors.code = "Code is Required";
    }

    if (!customerFormData.name) {
      setIsValidName(false);
      errors.name = "Name is Required";
    }

    if (!customerFormData.routeId) {
      setIsValidRoute(false);
      errors.route = "Route is Required";
    } 
    
    if (!customerFormData.phone1) {
      setIsValidPhone1(false);
      errors.phone1 = "Phone is Required";
    }

    setCustomerFormData((prevState) => ({ ...prevState, errors }));
    
    // return true if there are no errors
    return Object.keys(errors).length === 0;
  };

  // change input validation state
  const setIsValidInputs = (isValid) => {
    setIsValidCode(isValid);
    setIsValidName(isValid);
    setIsValidRoute(isValid);
    setIsValidPhone1(isValid);
  };

  // clear inputs
  const clearFormInputs = () => {
    setCustomerFormData({
      id: '',
      code: '',
      name: '',
      address: '',
      phone1: '',
      phone2: '',
      active: 'Active',
      routeId: 0,
      errors: {},
    });
  };

  // initialize inputs and state
  const initialize = () => {
    //basic
    clearFormInputs();
    setOperationMode("new");
    setIsValidInputs(true);
    setCustomerStatus("Active");
  };

  //++++ Sample List Tab Pane  +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // Sample Status Drop Down
  const [selectedSampleStatus, setSelectedSampleStatus] = useState('ALL');

  // set sample for slidebar
  const [activatingSample, setActivatingSample] = useState('');
  
  // Sample List DataTable  
  const sampleTableRef = useRef();
  const [sampleTableRowData, setSampleTableRowData] = useState([]);  

  const [sampleTableColumnDefs, setSampleTableColumnDefs] = useState([
    { 
      colId: "id", 
      valueGetter: (r) => r.data.id, 
      flex: 1,
      hide: true 
    },    
    {
      colId: "code",
      headerName: "Sample Code",
      valueGetter: (r) => r.data.sampleCode,
      filter: true,
      flex: 1,      
    },    
    {
      colId: "assortment",
      headerName: "Assortment",
      valueGetter: (r) => r.data.assortment.code,
      flex: 1,
      hide: false,
      filter: true
    },
    {
      colId: "value",
      headerName: "Value",
      valueGetter: (r) => 'Rs.'+(r.data.planValue.valueOfInstallment * r.data.planValue.noOfInstallment),
      flex:1,
      hide: false,
      filter: true
    },    
    {
      colId: "date",
      headerName: "Issued Date",
      valueGetter: (r) => r.data.issueDate,
      flex:1,
      hide: false,
      filter: true
    },    
    {
      colId: "duration",
      headerName: "Duration (days)",
      valueGetter: (r) =>['DELIVERED','PENDING'].includes(r.data.recentSampleTrackingLog.sampleStatus)?Math.floor([new Date() - new Date(r.data.issueDate)]/(1000*60*60*24))+1:'',
      cellStyle: { textAlign: 'center',fontSize: '14px'},        
      flex: 0.8,
    }, 
    {
      colId: "status",
      headerName: "Status",
      cellRenderer: (r)=> <span className={`text-sm font-semibold 
                              ${r.data.recentSampleTrackingLog.sampleStatus === 'DELIVERED'? 'text-yellow-500':
                                r.data.recentSampleTrackingLog.sampleStatus === 'PENDING'? 'text-orange-500':
                                r.data.recentSampleTrackingLog.sampleStatus === 'CONFIRMED'? 'text-green-500':
                                r.data.recentSampleTrackingLog.sampleStatus === 'ACTIVE'? 'text-blue-500':
                                r.data.recentSampleTrackingLog.sampleStatus === 'REJECTED'? 'text-red-500':''
                              }`}>
                              {r.data.recentSampleTrackingLog.sampleStatus}
                          </span>,
      flex:1,
      hide: false,      
    },
    {
      colId: "operaion",
      headerName: "Active  |  View",
      headerClass: 'no-separator',
      cellRenderer: (r) => <span>
                            <button type="button"
                              onClick={() => {handledSampleActiveButton(r)}}
                              disabled={['CONFIRMED'].includes(r.data.recentSampleTrackingLog.sampleStatus)? false:true}                                                     
                              className="text-blue-800 hover:text-blue-400 border-0 font-medium text-sm px-1 py-1.5 text-center
                                        disabled:text-gray-500"
                              >Active
                            </button>
                            <button type="button"
                              onClick={() => {}}                               
                              className="text-blue-800 hover:text-blue-400 border-0 font-medium text-sm px-1 py-1.5 text-center ml-2"
                              >View
                            </button>
                            <span className={`${r.data.recentSampleTrackingLog.sampleStatus !== 'CONFIRMED'? 'hidden':''} absolute h-2 w-2 mt-4 ml-2 animate-ping rounded-full bg-master_color-600`}></span>                             
                          </span>,             
      flex: 1,
    }, 
    
  ]);

  const fetchSampleTableData = async (customerId) => {
      try {
        if(customerId !== ''){
          setSampleTableRowData([])
          const res = await getSampleListByCustomerIdWithRecentTrackingLog(loggedUser.token, customerId);                
          setSampleTableRowData(res.data);
        }        
      } catch (error) {
        console.error("Customer -> fetchSampleTableData: ", error);
      }
  };


  useEffect(() => {
    fetchSampleTableData(customerFormData.id)   
   }, [customerFormData.id]);
  
  const handledSampleActiveButton = (sample) => {
    setActivatingSample(sample)   
  } 

  const handleSampleStatusChange = (e) => {
    const status = e.target.value;    
    setSelectedSampleStatus(status)    
  };

  //++++ Ticket List Tab Pane  +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // Ticket Status Drop Down
  const [selectedTicketStatus, setSelectedTicketStatus] = useState('ALL');

  // set ticket for slidebar
  const [updatingTicket, setUpdatingTicket] = useState('');
  const [viewingTicket, setViewingTicket] = useState('')
  
  // Ticket List DataTable  
  const ticketTableRef = useRef();
  const [ticketTableRowData, setTicketTableRowData] = useState([]);  

  const [ticketTableColumnDefs, setTicketTableColumnDefs] = useState([
    { 
      colId: "", 
      valueGetter: (r) => r.data.id, 
      flex: 1,
      hide: true 
    },    
    {
      colId: "",
      headerName: "Ticket Code",
      valueGetter: (r) => r.data.ticketCode,
      filter: true,
      flex: 1,      
    },    
    {
      colId: "",
      headerName: "Plan",
      valueGetter: (r) => r.data.sample.planValue.plan.code,
      flex: 1,
      hide: false,
      filter: true
    },
    {
      colId: "",
      headerName: "Value",
      valueGetter: (r) => 'Rs.'+(r.data.sample.planValue.valueOfInstallment * r.data.sample.planValue.noOfInstallment),
      flex:1,
      hide: false,
      filter: true
    },      
    {
      colId: "",
      headerName: "Current Inst.",
      valueGetter: (r) => '',
      flex:1,
      hide: false,
      filter: true
    },    
    {
      colId: "",
      headerName: "Last Update",
      valueGetter: (r) => '',
      cellStyle: { textAlign: 'center',fontSize: '14px'},        
      flex: 1,
    }, 
    {
      colId: "status",
      headerName: "Status",
      cellRenderer: (r)=> <span className={`text-sm font-semibold 
                              ${r.data.status === 'PENDING'? 'text-yellow-500':
                                r.data.status === 'OVERDUE'? 'text-orange-500':
                                r.data.status === 'ONGOING'? 'text-green-500':
                                r.data.status === 'COMPLETED'? 'text-blue-500':
                                r.data.status === 'DEFAULTED'? 'text-red-500':
                                r.data.status === 'CANCELLED'? 'text-red-500':''
                              }`}>
                              {r.data.status}
                          </span>,
      cellStyle: {fontSize: ''}, 
      flex:1,
      hide: false,      
    },
    {
      colId: "operaion",
      headerName: "View  |  Update",      
      cellRenderer: (r) => <span>
                            <button type="button"
                              onClick={() => {handledTicketViewButton(r)}}                                                                                   
                              className="text-blue-800 hover:text-blue-400 border-0 font-medium text-sm px-1 py-1.5 text-center"                                        
                              >View
                            </button>
                            <button type="button"
                              onClick={() => {handledTicketUpdateButton(r)}}                               
                              className="text-blue-800 hover:text-blue-400 border-0 font-medium text-sm px-1 py-1.5 text-center ml-2"
                              >Update
                            </button>                                                         
                          </span>,             
      flex: 1,
    }, 
    
  ]);


  const fetchTicketTableData = async (customerCode) => {
      try {
        if(customerCode !== ''){
          setTicketTableRowData([])
          const ticketList = await getTicketListByCustomerCode(loggedUser.token,customerCode)                
          setTicketTableRowData(ticketList.data);
        }
        
      } catch (error) {
        console.error("Customer -> fetchTicketTableData: ", error);
      }
  };
  
  const handledTicketUpdateButton = (ticket) => {
    setUpdatingTicket(ticket)
  } 

  const handledTicketViewButton = (ticket) =>{
    setViewingTicket(ticket)
  }


  const handleTicketStatusChange = (e) => {
    const status = e.target.value;    
    setSelectedSampleStatus(status)    
  };

  

  //++++ Tab Layout  +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  const [tab_1_Hide, setTab_1_Hide] = useState("");
  const [tab_2_Hide, setTab_2_Hide] = useState("hidden");
  const [tab_3_Hide, setTab_3_Hide] = useState("hidden");
  const [tab_4_Hide, setTab_4_Hide] = useState("hidden");

  const TAB_ACTIVE_CSS = "text-master_color-400 border-master_color-400";
  const [tab_1_active_css, setTab_1_active_css] = useState(TAB_ACTIVE_CSS);
  const [tab_2_active_css, setTab_2_active_css] = useState("");
  const [tab_3_active_css, setTab_3_active_css] = useState("");
  const [tab_4_active_css, setTab_4_active_css] = useState("");

  const toggleTab = (id) => {
    if (id === 1) {
      setTab_1_Hide("");
      setTab_2_Hide("hidden");
      setTab_3_Hide("hidden");
      setTab_4_Hide("hidden");

      setTab_1_active_css(TAB_ACTIVE_CSS);
      setTab_2_active_css("");
      setTab_3_active_css("");
      setTab_4_active_css("");
    }

    if (id === 2) {
      setTab_1_Hide("hidden");
      setTab_2_Hide("");
      setTab_3_Hide("hidden");
      setTab_4_Hide("hidden");

      setTab_1_active_css("");
      setTab_2_active_css(TAB_ACTIVE_CSS);
      setTab_3_active_css("");
      setTab_4_active_css("");
    }

    if (id === 3) {
      setTab_1_Hide("hidden");
      setTab_2_Hide("hidden");
      setTab_3_Hide("");
      setTab_4_Hide("hidden");

      setTab_1_active_css("");
      setTab_2_active_css("");
      setTab_3_active_css(TAB_ACTIVE_CSS);
      setTab_4_active_css("");
    }

    if (id === 4) {
      setTab_1_Hide("hidden");
      setTab_2_Hide("hidden");
      setTab_3_Hide("hidden");
      setTab_4_Hide("");

      setTab_1_active_css("");
      setTab_2_active_css("");
      setTab_3_active_css("");
      setTab_4_active_css(TAB_ACTIVE_CSS);
    }
  };

  

  
  /****** Right Pane - end ******************************************************************************************************************/

  return (
    <div className="flex h-full">
      <div id="left-pane" className="w-1/5 z-10">
        <div
          className={`bg-white absolute top-0 bottom-0 ${leftPaneStyle}  border-solid border-r border-slate-300`}
        >
          <div className="grid grid-cols-2">
            <div className="col-start-1 mt-1.5 ml-2.5">
              <p className="text-master_color-400 font-semibold text-lg font-sans drop-shadow mb-1.5">
                Customer List
              </p>
            </div>
            <div className="col-start-2 flex justify-end">
              <button
                onClick={handleExpandLeftPane}
                className="text-master_color-400 font-bold rounded mt-1 mr-1"
              >
                {leftPaneExpandedButtonIcon}
              </button>
            </div>
            <div className="col-span-2 p-0"></div>
          </div>
          <hr className="border-slate-300 border-0.5 ml-0.5 mr-0.5"></hr>

          <div className={`h-[calc(100%_-_2.5rem)] p-2`}>
            <div className="ag-theme-quartz h-full">
              <AgGridReact
                ref={customerTableRef}
                columnDefs={customerTableColumnDefs}
                rowData={customerTableRowData}
                pagination={!paginationlHide}
                paginationPageSize={10}
                paginationPageSizeSelector={[5, 10, 15]}
                defaultColDef={useMemo(() => ({ suppressMovable: true }), [])}
                rowSelection={"single"}
                onSelectionChanged={handledOnRowClick}
                //onRowDoubleClicked={handledOnRowDoubleClick}                
              />
            </div>
          </div>
        </div>
      </div>

      <div id="right-pane" className="w-4/5 z-0">
        <div id="button-container" className="flex gap-1.5 pl-2">
          <div className="mt-1">
            <button
              type="button"
              onClick={handleNewButton}
              className="px-4 py-1.5 text-sm font-medium rounded text-white inline-flex items-center bg-master_color-400 hover:bg-master_color-200"
            >
              <FaPlus size={16} />
              &nbsp;New
            </button>
          </div>
          <div className="mt-1">
            <button
              type="button"
              disabled={customerStatus === "Active" ? false : true}
              onClick={handleSaveButton}
              className="px-4 py-1.5 text-sm font-medium rounded text-white inline-flex items-center bg-master_color-400 hover:bg-master_color-200"
            >
              <FaSave size={16} />
              &nbsp;Save
            </button>
          </div>
          <div className="mt-1">
            <button
              type="button"
              disabled={operationMode === "new" ? true : false}
              onClick={handleDeleteButton}
              className="px-3 py-1.5 text-sm font-medium rounded text-white inline-flex items-center bg-master_color-400 hover:bg-master_color-200"
            >
              <FaCircleXmark size={16} />
              &nbsp;Delete
            </button>
          </div>
          <div className="mt-1">
            <button
              type="button"
              disabled={operationMode === "new" ? true : false}
              onClick={handleActiveButton}
              className="w-28 px-3 py-1.5 text-sm font-medium rounded text-white inline-flex items-center bg-master_color-400 hover:bg-master_color-200"
            >
              {customerStatus === "Active" ? (
                <FaSquare size={12} color="red" />
              ) : (
                <FaCircle size={12} color="green" />
              )}
              &nbsp;
              {customerStatus === "Active" ? "Deactivate" : "Reactivate"}
            </button>
          </div>
          <div className="mt-2.5 ml-6 flex w-auto">
            <Notification response={apiResponse} />
          </div>
        </div>

        <hr className="border-slate-300 border-0.5 mt-1"></hr>

        <div id="tab-container" className="h-[calc(100%_-_6.5rem)]">
          <div
            id="customer-info-tab-pane"
            className={`p-6 pt-1 ${tab_1_Hide}`}
            role="tabpanel"
          >
            <div className="grid grid-cols-3 gap-12">
              <div id="row-1-col-1">
                <div className="text-master_color-300 text-lg font-semibold drop-shadow-sm">
                  Basic
                </div>
                <div className="grid grid-cols-3 mt-1">
                  <div className="pt-0.5 font-sans drop-shadow">
                    Customer Code
                  </div>
                  <div className="col-span-2">
                    <input
                      type="text"
                      name="code"
                      value={customerFormData.code}
                      onChange={handleBasicInputChange}
                      disabled={true}
                      placeholder="Required"
                      className={`w-full text-sm pl-2 py-1 outline-none bg-gray-100 border focus:border-master_color-200 rounded
                            ${
                              customerStatus === "Active"
                                ? "bg-white"
                                : "bg-gray-200"
                            }
                            ${
                              isValidCode
                                ? "border-slate-400"
                                : "border-red-600"
                            }                             
                            `}
                    />
                  </div>
                </div>
                <div className="grid grid-cols-3 mt-2">
                  <div className="pt-0.5 font-sans drop-shadow">Name</div>
                  <div className="col-span-2">
                    <input
                      type="text"
                      name="name"
                      value={customerFormData.name}
                      onChange={handleBasicInputChange}
                      placeholder="Required"
                      disabled={customerStatus === "Active" ? false : true}
                      className={`w-full text-sm pl-2 py-1 outline-none border  focus:border-master_color-200 rounded                            
                            ${
                              customerStatus === "Active"
                                ? "bg-white"
                                : "bg-gray-200"
                            }
                            ${
                              isValidName
                                ? "border-slate-400"
                                : "border-red-600"
                            } 
                            `}
                    />
                  </div>
                </div>
                <div className="grid grid-cols-3 mt-2">
                  <div className="pt-0.5 font-sans drop-shadow">Route</div>
                  <div className="col-span-2">
                    <select
                      name="routeId"
                      value={customerFormData.routeId}
                      onChange={handleBasicInputChange}
                      disabled={customerStatus === "Active" ? false : true}
                      className={`w-full pl-1 py-1 text-sm outline-none border focus:border-master_color-200 rounded 
                                    ${
                                      isValidRoute
                                        ? "border-slate-400"
                                        : "border-red-600"
                                    }
                                    ${
                                      customerStatus === "Active"
                                        ? "bg-white"
                                        : "bg-gray-200"
                                    }
                                    `}
                    >
                      <option value="0" disabled>
                        -- select route --
                      </option>
                      {activeRouteList.map((route) => (
                        <option key={route.id} value={route.id}>
                          {route.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              <div id="row-1-col-2">
                <div className="text-master_color-300 text-lg font-semibold drop-shadow-sm">
                  Contact
                </div>
                <div className="grid grid-cols-3 mt-1">
                  <div className="pt-0.5 font-sans drop-shadow">Phone 1</div>
                  <div className="col-span-2 flex">                   
                    <input
                      type="text"
                      name="phone1"
                      value={customerFormData.phone1}
                      onChange={handleBasicInputChange}
                      placeholder="Required"
                      disabled={customerStatus === "Active" ? false : true}
                      className={`w-full text-sm pl-2 py-1 outline-none border rounded focus:border-master_color-200                             
                            ${
                              isValidPhone1
                                ? "border-slate-400"
                                : "border-red-600"
                            }
                            ${
                              customerStatus === "Active"
                                ? "bg-white"
                                : "bg-gray-200"
                            } 
                            `}
                    />
                  </div>
                </div>
                <div className="grid grid-cols-3 mt-2">
                  <div className="pt-0.5 font-sans drop-shadow">Phone 2</div>
                  <div className="col-span-2 flex">                    
                    <input
                      type="text"
                      name="phone2"
                      value={customerFormData.phone2}
                      onChange={handleBasicInputChange}
                      placeholder=""
                      disabled={customerStatus === "Active" ? false : true}
                      className={`w-full text-sm pl-2 py-1 outline-none border rounded border-slate-400 focus:border-master_color-200                    
                            ${
                              customerStatus === "Active"
                                ? "bg-white"
                                : "bg-gray-200"
                            } 
                            `}
                    />
                  </div>
                </div>
              </div>
              <div id="row-1-col-3"></div>

              <div id="row-2-col-1">
                <div className="text-master_color-300 text-lg font-semibold drop-shadow-sm">
                  Address
                </div>
                <div className="mt-2">
                  <textarea
                    type="text"
                    name="address"
                    value={customerFormData.address}
                    onChange={handleBasicInputChange}
                    disabled={customerStatus === "Active" ? false : true}
                    className={`w-full h-24 text-base pl-2 py-1 outline-none border border-slate-400 focus:border-master_color-200 rounded                                       
                                ${
                                  customerStatus === "Active"
                                    ? "bg-white"
                                    : "bg-gray-200"
                                } 
                              `}
                  />
                </div>
              </div>
              <div id="row-2-col-2"></div>
              <div id="row-2-col-3"></div>

              <div id="row-3-col-1"></div>
              <div id="row-3-col-2"></div>
              <div id="row-3-col-3"></div>
            </div>
          </div>

          <div
            id="customer-geo-data-tab-pane"
            className={`p-4 pt-1 ${tab_2_Hide} h-full`}
            role="tabpanel"
          >
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d15831.162623204676!2d80.59938464999999!3d7.2646493!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2slk!4v1731697563874!5m2!1sen!2slk"
              width="800"
              height="400"
              title="hi"
              style={{ border: 0 }}
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>

          <div
            id="customer-sample-list-tab-pane"
            className={`p-4 pt-1 ${tab_3_Hide} h-full`}
            role="tabpanel"
          >
            <div className="">              
              <div className="text-master_color-300 text-lg font-semibold drop-shadow-sm">
                Sample List                             
              </div> 
              <div className="flow-row mt-1 hidden">{/*change hidden to flex */}
                <div className="basis-1/8 pt-0.5 font-sans drop-shadow">
                  Sample Status                  
                </div>
                <div className="basis-7/8 pl-3 grow">
                  <select                    
                    value={selectedSampleStatus}  
                    onChange={handleSampleStatusChange}              
                    className={`w-full pl-1 py-1 text-sm outline-none border border-slate-400 focus:border-master_color-200 rounded`}                  
                  >                                       
                    <option value="All">All</option>
                    <option value="DELIVERED">Delivered</option>
                    <option value="PENDING">Pending</option>
                    <option value="CONFIRMED">Confirmed</option>
                    <option value="ACTIVE">Active</option>
                    <option value="REJECTED">Rejected</option>
                  </select>
                </div>
              </div>                                
            </div>
            <div className="h-full pb-12">
              <div className="ag-theme-quartz h-full pt-2" >
                <AgGridReact                  
                  ref={sampleTableRef}
                  columnDefs={sampleTableColumnDefs} 
                  defaultColDef={{
                    resizable: false,
                  }}                 
                  rowData={sampleTableRowData}                   
                  getRowId={params => `sample-${params.data.id}`}                 
                  rowSelection={"single"}
                  //onSelectionChanged={handledOnRowClick}
                  pagination={true}
                  paginationPageSize={10}
                  paginationPageSizeSelector={[5, 10, 15]}                               
                />
              </div>
              <SampleActivateSlideBar activatingSample={activatingSample}/>
            </div>            
          </div>

          <div
            id="customer-ticket-list-tab-pane"
            className={`p-4 pt-1 ${tab_4_Hide} h-full`}
            role="tabpanel"
          >
           
           <div className="">              
              <div className="text-master_color-300 text-lg font-semibold drop-shadow-sm">
               Ticket List
              </div> 
              <div className="flow-row mt-1 hidden">{/*change hidden to flex */}
                <div className="basis-1/8 pt-0.5 font-sans drop-shadow">
                  Ticket Status
                </div>
                <div className="basis-7/8 pl-3 grow">
                  <select                    
                    value={selectedSampleStatus}  
                    onChange=""              
                    className={`w-full pl-1 py-1 text-sm outline-none border border-slate-400 focus:border-master_color-200 rounded`}                  
                  >                                       
                    <option value="All">All</option>
                    <option value="DELIVERED">Delivered</option>
                    <option value="PENDING">Pending</option>
                    <option value="CONFIRMED">Confirmed</option>
                    <option value="ACTIVE">Active</option>
                    <option value="REJECTED">Rejected</option>
                  </select>
                </div>
              </div>                                
            </div>
            <div className="h-full pb-12">
              <div className="ag-theme-quartz h-full pt-2">
                <AgGridReact
                  ref={ticketTableRef}
                  columnDefs={ticketTableColumnDefs}
                  defaultColDef={{
                    resizable: false,
                  }}  
                  rowData={ticketTableRowData}  
                  getRowId={params => `ticket-${params.data.id}`}                
                  rowSelection={"single"}
                  //onSelectionChanged={handledOnRowClick}
                  pagination={true}
                  paginationPageSize={10}
                  paginationPageSizeSelector={[5, 10, 15]}                               
                />
              </div>
              <TicketUpdateSlideBar updatingTicket={updatingTicket}/>
              <TicketViewSlideBar viewingTicket={viewingTicket}/>
            </div>

          </div>
        </div>

        <div
          id="tab-button-container"
          className="mb-4 border-b border-gray-200"
        >
          <ul
            className="flex flex-wrap -mb-px text-sm font-medium text-center"
            id="default-styled-tab"
            data-tabs-toggle="#default-styled-tab-content"
            data-tabs-active-classes="text-master_color-400 hover:text-master_color-400 border-master_color-400 "
            data-tabs-inactive-classes="dark:border-transparent text-gray-500 hover:text-gray-600 dark:text-gray-400 border-gray-100 hover:border-gray-300 dark:border-gray-700 dark:hover:text-gray-300"
            role="tablist"
          >
            <li className="me-2" role="presentation">
              <button
                className={`inline-block p-4 border-b-2 rounded-t-lg hover:text-master_color-400 hover:border-master_color-400 drop-shadow-sm ${tab_1_active_css}`}
                id="profile-styled-tab"
                data-tabs-target="#styled-profile"
                type="button"
                role="tab"
                aria-controls="profile"
                aria-selected="false"
                onClick={() => toggleTab(1)}
              >
                Customer Info
              </button>
            </li>
            <li className="me-2" role="presentation">
              <button
                className={`inline-block p-4  border-b-2 rounded-t-lg hover:text-master_color-400 hover:border-master_color-400 ${tab_2_active_css}`}
                id="dashboard-styled-tab"
                data-tabs-target="#styled-dashboard"
                type="button"
                role="tab"
                aria-controls="dashboard"
                aria-selected="false"
                onClick={() => toggleTab(0)}
              >
                Geo Data
              </button>
            </li>
            <li className="me-2" role="presentation">
              <button
                className={`inline-block p-4 border-b-2 rounded-t-lg hover:text-master_color-400 hover:border-master_color-400 ${tab_3_active_css}`}
                id="dashboard-styled-tab"
                data-tabs-target="#styled-dashboard"
                type="button"
                role="tab"
                aria-controls="dashboard"
                aria-selected="false"
                onClick={() => toggleTab(3)}
              >
                Sample List
              </button>
            </li>
            <li className="me-2" role="presentation">
              <button
                className={`inline-block p-4 border-b-2 rounded-t-lg hover:text-master_color-400 hover:border-master_color-400 ${tab_4_active_css}`}
                id="dashboard-styled-tab"
                data-tabs-target="#styled-dashboard"
                type="button"
                role="tab"
                aria-controls="dashboard"
                aria-selected="false"
                onClick={() => toggleTab(4)}
              >
                Ticket List
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
